import { formatCurrencyForDisplay } from '@utils'
import { useCurrencies } from 'mmfintech-backend-api'
import { formatFloat } from 'mmfintech-commons'
import type { ReactNode } from 'react'

import styles from './MainAmountRow.module.scss'

type MainAmountRowProps = {
  label: ReactNode
  amount: number
  currency: string
  'data-test'?: string
}

const MainAmountRow = (props: MainAmountRowProps) => {
  const { label, amount, currency, 'data-test': dataTest = 'main-amount' } = props

  const { getCurrencyPrecision } = useCurrencies()

  return (
    <div className={styles['main-amount-wrapper']}>
      <div className='amount-label'>{label}</div>
      <div className='amount-value'>
        <span data-test={`${dataTest}-value`}>{formatFloat(amount, getCurrencyPrecision(currency))}</span>
        <span className='amount-currency' data-test={`${dataTest}-currency`}>
          {formatCurrencyForDisplay(currency)}
        </span>
      </div>
    </div>
  )
}

export default MainAmountRow
